import { Link } from 'react-router-dom'
import { allaKallor, hittaTeoripost } from '../lib/teorisektion'
import { useSidTitel } from '../lib/seo'
import { KallRad } from './ModellSida'

/** Samlad källförteckning: källorna som modellerna och teorierna vilar på,
 *  genererad ur teoriposternas källhänvisningar mot källregistret. Varje rad
 *  visar var i teorisektionen källan används. */
export default function KallorSida() {
  useSidTitel('Källförteckning')

  return (
    <div className="wrap">
      <article className="dokument">
        <nav className="brodsmula no-print" aria-label="Brödsmulor">
          <Link to="/modeller">Modeller och teorier</Link>
        </nav>
        <h1>Källförteckning</h1>
        <p>
          Det här materialet bygger på etablerade källor inom organisationsteori, psykologi och
          ledarskapsforskning. Förteckningen visar källorna bakom läromedlets modeller och
          teorier — varje sakpåstående i lärotexten är dessutom spårbart till en källa i
          produktionens källregister. Läs mer om kvalitetssäkringen på{' '}
          <Link to="/om">Om läromedlet</Link>.
        </p>

        <ul className="kallforteckning">
          {allaKallor.map((kalla) => (
            <li key={kalla.kalla_id}>
              <KallRad kalla={kalla} />
              {kalla.typ && <span className="kalla-typ"> · {kalla.typ}</span>}
              <span className="kalla-anvands">
                {' '}
                Används av:{' '}
                {kalla.anvands_av.map((id, index) => {
                  const post = hittaTeoripost(id)
                  if (!post) return null
                  return (
                    <span key={id}>
                      {index > 0 && ', '}
                      <Link to={`/modeller/${id}`}>{post.namn}</Link>
                    </span>
                  )
                })}
              </span>
            </li>
          ))}
        </ul>
      </article>
    </div>
  )
}
